import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { InputProps } from "./types";
import { isValidEmail } from "./utils";
import Label from "./label";
import styles from "./styles";
import validator from "validator";

export const Input = (props: InputProps) => {
  const {
    name,
    label,
    cssName,
    labelCssName,
    fieldOptions = {},
    customValidationMessage,
    type = "text",
    placeHolder,
    ...rest
  } = props;

  const { register, formState: { errors } } = useFormContext();

  const handleEmailValidation = (value: string) => {
    const isValid = isValidEmail(value);

    // const validityChanged = (errors[name] && isValid) || (!errors[name] && !isValid);

    // if (validityChanged) {
    //     console.log("Fire tracker with", isValid ? "Valid" : "Invalid");
    // }

    return isValid;
  };

  const handleMobileNumberValidation = (value: string) => {
    const isValid = validator.isMobilePhone(value);
    return isValid;
  }

  if (type === "tel") {
    fieldOptions.validate = {
      checkMobileNumber: (value) => handleMobileNumberValidation(value) || customValidationMessage
    }
  }

  if (type === "email") {
    fieldOptions.validate = {
      //isRequired: (value) => value !== "" || "Required",
      checkEmail: (value) => handleEmailValidation(value) || customValidationMessage
    };
  }

  //Note label comes after input but to BS floating labels
  const renderError = ({ message }: { message: any }) => {
    return <p className="error">{message || customValidationMessage}</p>
  }

  return (<div className={cssName}>
    <input
      id={name}
      type={type}
      {...register(name, fieldOptions)}
      {...rest}
      className={styles.elements.input}
      placeholder={placeHolder ?? label} />

    <Label htmlFor={name} text={label} cssName={labelCssName} />

    <ErrorMessage
      errors={errors}
      name={name}
      render={renderError}
    />
  </div>);
}

export default Input;
